import React from 'react'

const Search = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/search',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g
      fill='none'
      fillRule='evenodd'
      stroke={primaryColor}
      strokeWidth='1.5'
      transform='translate(2 2)'
    >
      <circle cx={5.982} cy={5.982} r={5.982} />
      <path d='M10.107 10.313l4.853 4.853' strokeLinecap='round' />
    </g>
  </svg>
)

export default Search
